export default __webpack_public_path__ + "static/char-s-58-en-0d14ee5a0f539c120bc2346c82fd5ad0.png";